import { gql } from "apollo-boost"

export const ceateRejectLog = gql`
mutation createRejectLog($data: CreateRejectLogInput!) {
  CreateRejectLog(data: $data)
  }  
`